module.exports = __webpack_public_path__ + "img/phone-illustration.b0c98c17.svg";